var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sideholder"},[_c('div',{staticClass:"settings"},_vm._l((_vm.settingList),function(set,index){return _c('div',{key:index,staticClass:"setting-item",class:{'active' : set.route == _vm.$store.state.navigation},on:{"click":function($event){_vm.$store.state.navigation = set.route}}},[_vm._v(_vm._s(set.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }